
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class TaskInstanceGrid extends SiteEntityGrid<TaskInstanceRow, any> {
        protected getColumnsKey() { return 'Workflow.TaskInstance'; }
        protected getDialogType() { return TaskInstanceDialog; }
        protected getIdProperty() { return TaskInstanceRow.idProperty; }
        protected getLocalTextPrefix() { return TaskInstanceRow.localTextPrefix; }
        protected getService() { return TaskInstanceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

    }
}